/* One login-first flow for the club page, product forms and both cart layouts. */
(function () {
  'use strict';
  var root = document.getElementById('loow-woolclub');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  var da = root.dataset.locale === 'da';
  var prefix = da ? '/da' : '';
  var state = root.dataset.state;
  // Tagged member without newsletter consent: subscribing reactivates, it is not a new signup.
  var paused = root.dataset.paused === 'true';
  var dialog = root.querySelector('[data-wc-dialog]');
  var consentForm = root.querySelector('[data-wc-consent-form]');
  var survey = root.querySelector('[data-wc-acquisition-form]');
  var source = survey.querySelector('[data-wc-acquisition-source]');
  var detail = survey.querySelector('[data-wc-acquisition-detail]');
  var error = root.querySelector('[data-wc-error]');
  var status = root.querySelector('[data-wc-status]');
  var activeTrigger, overflow = '', busy = false, enrolled = false, stage = '';
  var target = window.location.pathname + window.location.search;
  var key = 'loow_woolclub_return_v1';
  var text = function (dk, en) { return da ? dk : en; };
  var storage = {
    get: function () { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } },
    set: function (value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* URL marker still resumes login. */ } },
    clear: function () { try { sessionStorage.removeItem(key); } catch (_) {} }
  };
  function localURL(value) {
    var url = new URL(value || (prefix + '/pages/the-wool-club'), window.location.origin);
    return url.origin === window.location.origin ? url : new URL(prefix + '/pages/the-wool-club', window.location.origin);
  }
  function currentTarget(trigger) {
    if (trigger.dataset.wcContext === 'cart') {
      var cart = localURL(prefix + '/cart');
      // Preserve staging preview across login without carrying a checkout URL.
      var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview) cart.searchParams.set('preview_theme_id', preview);
      return cart.pathname + cart.search;
    }
    if (trigger.dataset.wcContext !== 'product') return window.location.pathname + window.location.search;
    var url = localURL(trigger.dataset.wcProductUrl);
    if (da && !url.pathname.startsWith('/da/')) url.pathname = '/da' + url.pathname;
    var form = trigger.closest('form');
    var product = trigger.closest('[data-product-id]') || form;
    var variant = form && form.querySelector('[name="id"]');
    var quantity = product && product.querySelector('[name="quantity"]');
    if (variant && variant.value) url.searchParams.set('variant', variant.value);
    if (quantity) url.searchParams.set('wc_quantity', quantity.value);
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search;
  }
  function hide() {
    dialog.hidden = true;
    document.body.style.overflow = overflow;
    if (activeTrigger && activeTrigger.isConnected) activeTrigger.focus();
  }
  function show(nextStage) {
    if (dialog.hidden) overflow = document.body.style.overflow;
    stage = nextStage;
    consentForm.hidden = stage !== 'consent';
    survey.hidden = stage !== 'survey';
    root.querySelector('#wc-dialog-title').textContent = stage === 'survey'
      ? text('Hvor hørte du først om LOOW?', 'Where did you first hear about LOOW?')
      : paused ? text('Dit medlemskab er sat på pause', 'Your membership is paused')
      : text('Bliv medlem af The WOOL Club, gratis', 'Join The WOOL Club for free');
    error.hidden = true;
    status.textContent = '';
    dialog.hidden = false;
    document.body.style.overflow = 'hidden';
    (stage === 'survey' ? source : consentForm.querySelector('input')).focus();
  }
  function complete() {
    storage.clear();
    hide();
    var url = localURL(target);
    url.searchParams.delete('wc_resume');
    window.location.assign(url.pathname + url.search);
  }
  function close() {
    if (busy && stage === 'consent') return;
    if (enrolled) complete();
    else { storage.clear(); hide(); }
  }
  function begin(trigger) {
    if (busy) return;
    activeTrigger = trigger;
    target = currentTarget(trigger);
    if (state === 'member') { complete(); return; }
    if (state === 'guest') {
      var url = localURL(target);
      url.searchParams.set('wc_resume', '1');
      storage.set({ target: target, at: Date.now() });
      window.location.assign('/customer_authentication/login?return_to=' + encodeURIComponent(url.pathname + url.search) + '&locale=' + encodeURIComponent(root.dataset.locale || 'en'));
    } else show('consent');
  }
  async function send(payload) {
    // A unique signed proxy query separates signup from the survey in the replay ledger.
    var response = await fetch('/apps/recommend/woolclub-join?request_id=' + crypto.randomUUID(), {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload), signal: AbortSignal.timeout(20000)
    });
    var result = await response.json();
    if (!response.ok || result.ok !== true) throw new Error('woolclub_request_failed');
    return result;
  }
  function submitting(form, value) {
    busy = value;
    form.querySelector('[type="submit"]').disabled = value;
    form.setAttribute('aria-busy', String(value));
  }
  consentForm.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (busy || !consentForm.reportValidity()) return;
    submitting(consentForm, true);
    error.hidden = true;
    status.textContent = text('Tilmelder dig…', 'Signing you up…');
    try {
      var result = await send({ accepts_marketing: true, locale: da ? 'da' : 'en' });
      enrolled = true;
      state = 'member';
      storage.clear();
      if (!result.already_member && !paused) {
        try {
          await fetch(prefix + '/cart/update.js', {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { wool_club_signup: 'true', wool_club_signup_at: new Date().toISOString() } }),
            signal: AbortSignal.timeout(5000)
          });
        } catch (_) { /* Membership is already confirmed; do not repeat signup. */ }
      }
      if (result.already_member || paused) complete();
      else show('survey');
    } catch (_) {
      error.textContent = text('Tilmeldingen kunne ikke bekræftes. Prøv igen. Dine varer er stadig i kurven.', 'We could not confirm your signup. Please try again. Your cart is unchanged.');
      error.hidden = false;
      status.textContent = '';
    } finally { submitting(consentForm, false); }
  });
  source.addEventListener('change', function () {
    detail.hidden = source.value !== 'other';
    detail.required = !detail.hidden;
    if (detail.hidden) detail.value = '';
  });
  survey.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (busy || !survey.reportValidity()) return;
    if (!detail.hidden && !detail.value.trim()) { detail.focus(); return; }
    submitting(survey, true);
    error.hidden = true;
    try {
      await send({ mode: 'attribution', locale: da ? 'da' : 'en', acquisition_source: source.value,
        acquisition_detail: detail.hidden ? undefined : detail.value.trim() });
      complete();
    } catch (_) {
      error.textContent = text('Svaret kunne ikke gemmes. Prøv igen, eller luk vinduet og fortsæt. Du er allerede medlem.', 'Your answer could not be saved. Try again, or close this window to continue. You are already a member.');
      error.hidden = false;
    } finally { submitting(survey, false); }
  });
  root.querySelector('[data-wc-close]').addEventListener('click', close);
  dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
    if (event.key !== 'Tab') return;
    var elements = Array.from(dialog.querySelectorAll('button:not(:disabled),input,select,a[href]')).filter(function (el) { return el.getClientRects().length; });
    var first = elements[0], last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-wc-trigger]');
    if (!trigger || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    begin(trigger);
  });
  // Implicit form submission (e.g. Enter) must not call the theme's AJAX cart handler.
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form[data-wc-locked="true"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      var trigger = event.target.querySelector('[data-wc-trigger]');
      if (trigger) begin(trigger);
    }
  }, true);
  function resume() {
    var url = new URL(window.location.href);
    var quantity = url.searchParams.get('wc_quantity');
    if (quantity && /^\d+$/.test(quantity) && Number(quantity) > 0) {
      document.querySelectorAll('.product-single__meta [name="quantity"], [data-product-type="original"] [name="quantity"]').forEach(function (input) {
        input.value = quantity; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    var pending = storage.get();
    if (url.searchParams.get('wc_resume') !== '1') return;
    url.searchParams.delete('wc_resume');
    target = url.pathname + url.search;
    // Session state is only a navigation hint, never membership or consent.
    if (pending && Date.now() - pending.at < 30 * 60 * 1000) target = localURL(pending.target).pathname + localURL(pending.target).search;
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    storage.clear();
    if (state === 'logged-in') show('consent');
    // A member is already at the original destination, without a survey or mutation.
  }
  if (document.readyState === 'complete') resume();
  else window.addEventListener('load', resume, { once: true });
})();
